import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: 'https://cdn-prod.seismic.com/static/seismic-i18n/UniversalVideoRecorder/{{ns}}/{{lng}}.json',
      allowMultiLoading: false,
      crossDomain: true
    },
    load: 'currentOnly',
    fallbackLng: 'en-US',
    ns: 'Default',
    defaultNS: 'Default',
    keySeparator: false,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false
    },
    debug: true
  });

export default i18n;
